import { render, staticRenderFns } from "./FlipCardSideProperties.vue?vue&type=template&id=eddebb14"
import script from "./FlipCardSideProperties.vue?vue&type=script&lang=js"
export * from "./FlipCardSideProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports